// LIBRAIRIES
require('webpack-jquery-ui');
require('webpack-jquery-ui/css');
require("@fancyapps/fancybox");
require('slick-carousel/slick/slick-theme.css');
require('slick-carousel/slick/slick.js');
require('slick-carousel/slick/slick.css');
require('slick-carousel');
require('jquery-mask-plugin/src/jquery.mask');
require('aos')
require('aos/dist/aos.js')
require('aos/dist/aos.css')

//SCSS
import '../scss/styles.scss';

//Fonts
import '../fonts/Haffermoi-SemiBold.otf';
import '../fonts/Haffermoi-Bold.otf';
import '../fonts/Haffermoi-Regular.otf';
import '../fonts/Haffermoi-SemiBold.woff';
import '../fonts/Haffermoi-Bold.woff';
import '../fonts/Haffermoi-Regular.woff';

//GLOBAL JS ONLY
import './dashboard/overview.ts';
import './form/form.ts';
import './header.ts';
import './loginEvents.js';
import './cookieConsent.ts';
import './common/tink.js';
import './common/validation.ts';
import './canadaPost/canadapostAddress.js'
import './modal/modal.ts';
import './home/ip-detection.ts';
import './footer.ts';
import './global.ts';
import './profile/rbcBanner.ts';
import './barcode/cardPrint.ts';
import './common/cybermetrie.js';
import './specific/slider-inscription.js';

//Images
import '../images/icon-x.png';
import '../images/icon-x-white.svg';
import '../images/check-yellow.png';
import '../images/squared-woman.png';
import '../images/squared-woman@2x.png';
import '../images/rounded-hands.png';
import '../images/rounded-hands@2x.png';
import '../images/squared-man.png';
import '../images/squared-man@2x.png';
import '../images/icon-check.svg';
import '../images/icon-plus.svg';
import '../images/icon-check-grey.svg';
import '../images/icon-check-slider.svg';
import '../images/icon-plus-grey.svg';
import '../images/icon-arrow.svg';
import '../images/icon-arrow-black-shade.svg';
import '../images/icon-arrow-seance.svg';
import '../images/profil-femme-mauve.png';
import '../images/profil-femme-rose.png';
import '../images/profil-femme-verte.png';
import '../images/profil-homme-beige.png';
import '../images/profil-homme-orange.png';
import '../images/visa-moi-card.png';
import '../images/visa-moi-card@2x.png';
import '../images/img-hero-test@2x.png';
import '../images/img-hero-test-mob.png';
import '../images/icon-circle-confirmation.svg';
import '../images/icon-circle-error.svg';
import '../images/icon-circle-info.svg';
import '../images/img-oka-products.png';
import '../images/img-oka-products@2x.png';
import '../images/mask2x2.svg';
import '../images/mask4x2.svg';
import '../images/hero-femme-mauve.png';
import '../images/hero-femme-mauve@2x.png';
import '../images/hero-femme-jaune.png';
import '../images/hero-femme-jaune@2x.png';
import '../images/hero-femme-verte.png';
import '../images/hero-femme-verte@2x.png';
import '../images/hero-homme-beige.png';
import '../images/hero-homme-beige@2x.png';
import '../images/hero-homme-rouge.png';
import '../images/hero-homme-rouge@2x.png';
import '../images/cards-dots.png';
import '../images/cards-dots@2x.png';
import '../images/cards-dots-mobile.png';
import '../images/cards-dots-mobile@2x.png';
import '../images/next-gray.svg';
import '../images/favicon.svg';
import '../images/logomoi.svg';
import '../images/img-fb-moi.jpg';
import '../images/image-boite-gauche@2x.svg';
import '../images/image-boite-gauche-rewards@2x.svg';
import '../images/image-boite-droite@2x.png';
import '../images/image-profil@2x.png';
import '../images/image-profil.png';
import '../images/kit-adhesion-desktop.svg';
import '../images/kit-adhesion-mobile.svg';
import '../images/2cards.png'
import '../images/2cards@2x.png'
import '../images/card-moi.png'
import '../images/card-moi@2x.png'
import '../images/img-rounded-josee-orange.png';
import '../images/img-rounded-gaelle-mint.png';
import '../images/img-rounded-evelynn-beige.png';
import '../images/img-rounded-emile-green.png';
import '../images/img-rounded-richard-green.png';